// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__XSfMT","error":"Textarea_error__28TQ7","readonly":"Textarea_readonly__2hev5","disabled":"Textarea_disabled__sOvXc"};